import type { GeneratorCommand } from '../janus-engine/inventory/random-generator';
import type { SpawnSourcePackage } from '../janus-engine/spawn/source-plan';
import { withSpawnEntities } from '../janus-engine/spawn/applied-entities';
import type { SpawnRowPlan, Row } from '../janus-engine/spawn/row-plan';
import { spawnAppliedFrame } from '../janus-engine/transport/gm-applied-frame';
import { ecId, record } from '../janus-engine/ability/context';
import { ftCurrentTruthSink, truthWriteRefusal } from './truth-sink';
import type {} from './applied-truth-transport';

export const GENERATOR_SAVE_PATH = 'options/tools/inventory/random_generator/generator_truth_commit_inc.php';

/** Each caller retains this one birth with its retry command. No bundle-owned state. */
export function prepareGeneratorDelivery(command: GeneratorCommand, inputs: SpawnSourcePackage, encounter: Row): (response: Response) => Promise<void> {
    if (ftCurrentTruthSink()) throw truthWriteRefusal(BASE_URL + GENERATOR_SAVE_PATH);
    if (!window.ftPushAppliedTruth) throw new Error('generator:truth-transport-unavailable');
    const tables = { inventory: 'inventory', status: 'statuses', template: 'enchantment_templates', member: 'enchantment_template_enchantments' } as const;
    const plan: SpawnRowPlan = { version: 'janus.spawn.rows.v1', writes: command.rows.map(({ kind, row }) => ({ table: tables[kind], op: 'insert', row })) };
    const first = Array.isArray(encounter.encounter_creatures_arr) ? encounter.encounter_creatures_arr.find(value => ecId(record(value))) : null;
    const identity = { operation_id: command.operation_id, encounter_id: command.destination_id, actor_id: ecId(record(first)) || command.destination_id, rev: 0, member_revs: {} };
    const creator = String((window as unknown as { FateTide?: { user?: { id?: unknown } } }).FateTide?.user?.id ?? '');
    const applied_frame = spawnAppliedFrame(identity, withSpawnEntities(plan, inputs, encounter, creator));
    let published = false;
    return async response => {
        if (published) return;
        published = true;
        // Publish after success/replay, then register the existing response. Claiming
        // the save first would dedup away this operation's first frame.
        const installed = window.ftPushAppliedTruth!({ type: 'janus_spawn_truth', command: identity, applied_frame });
        await window.ftSaveAppliedTruth?.(command.operation_id, async () => response);
        await installed;
    };
}
